import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class RealTimeWatch {
  static async getMainPic() {
    const [err, res] = await To(
      axios.get(
        'https://data2-api-zkj.test.wiz.top/index/findTreeDataByPageId?pageId=8&authCode=bf713354-a64a-4e96-bc7a-053b2475b7df'
      )
    )
    return Callback(err, res)
  }
  static async getMainPic1() {
    const [err, res] = await To(
      axios.get(
        'https://data2-api-zkj.test.wiz.top/index/findTreeDataByPageId?pageId=10&authCode=413406e9-3550-4a12-9a93-4c7a3f3d845e'
      )
    )
    return Callback(err, res)
  }
  // 获取测点详细信息
  static async getPointDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/threshold_config/threshold_config/thresholdconfig_point?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取机组ht相关信息
  static async getMenuHt(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/real_time_picture_config/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 保存组
  static async saveGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/shared_group', payload)
    )
    return Callback(err, res)
  }
  // 获取组数据
  static async getGroupData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/real_time_monitor/shared_group/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 编辑组
  static async editGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/real_time_monitor/shared_group', payload)
    )
    return Callback(err, res)
  }
  // 删除组
  static async deleteGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/real_time_monitor/shared_group?id=${payload.id}`)
    )
    return Callback(err, res)
  }
  // 分享组
  static async shareGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/shared_group/batch', payload)
    )
    return Callback(err, res)
  }
  // 获取实时监控配置列表
  static async getConfigData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/real_time_picture_config?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增实时监控配置列表
  static async addConfigData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/real_time_picture_config', payload)
    )
    return Callback(err, res)
  }
  // 编辑实时监控配置列表
  static async editConfigData(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/real_time_monitor/real_time_picture_config', payload)
    )
    return Callback(err, res)
  }
  // 生成表格
  static async exportExcel(payload) {
    // const params = _.pick(payload, ['tag_ids', 'type', 'flowchart'])
    // delete payload.type
    // delete payload.flowchart
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MeasuringPoint/export-chart', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取查询趋势列表数据
  static async getTrendData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MeasuringPoint/point-value', payload)
    )
    return Callback(err, res)
  }
  // 获取测点信息
  static async getPointsDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/measuring_point/points', payload)
    )
    return Callback(err, res)
  }
}
